import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=b98436c4&scoped=true&"
import script from "./AdminLogin.vue?vue&type=script&lang=js&"
export * from "./AdminLogin.vue?vue&type=script&lang=js&"
import style0 from "./AdminLogin.vue?vue&type=style&index=0&id=b98436c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98436c4",
  null
  
)

export default component.exports